import { SuretyAccountStatus } from "@inrev/common";
import { useFetchSuretyAccount } from "@portal/api/account";
import { AgentExposureSection } from "@portal/components/features/exposure";
import { Card } from "@portal/components/primitives";
import { FC } from "react";
import { AccountTabProps } from "../../../account/AccountLayout";
import { AccountBondsAndRequests } from "./AccountBondsAndRequests";
import { ActionItemsSection } from "./action-items/ActionItemsSection";
import { AgentUploadedDocuments } from "./attachments/AgentUploadedDocuments";
import { AccountBannerSection } from "./banners/AccountBannerSection";
import { AccountCommentsSection } from "./comments/AccountCommentsSection";

type AccountOverviewTabProps = AccountTabProps;

export const AccountOverviewTab: FC<AccountOverviewTabProps> = ({ accountId }) => {
	const { suretyAccount } = useFetchSuretyAccount(accountId);
	const isClosed = suretyAccount?.status === SuretyAccountStatus.closed;
	const isDeclined = suretyAccount?.status === SuretyAccountStatus.declined;

	return (
		<div
			className="relative min-h-[1050px] flex flex-col w-full pb-[125px]"
			data-testid="agent-account-overview-tab"
		>
			<div className="w-full flex flex-col space-y-[40px]">
				{!isClosed && <AccountBannerSection accountId={accountId} />}
				{!isClosed && <ActionItemsSection accountId={accountId} />}
				{!isClosed && !isDeclined && <AgentExposureSection accountId={accountId} />}
				{!isClosed && (
					<Card
						elevation="raised"
						className="rounded-xl"
						data-testid="agent-account-bonds-and-requests-card"
					>
						<Card.Body className="p-6">
							<AccountBondsAndRequests accountId={accountId} />
						</Card.Body>
					</Card>
				)}
				<Card elevation="raised" className="rounded-xl" data-testid="agent-account-messages-card">
					<Card.Body className="p-6">
						<AccountCommentsSection
							accountId={accountId}
							accountDisplayName={suretyAccount?.displayName ?? ""}
						/>
					</Card.Body>
				</Card>
				<AgentUploadedDocuments accountId={accountId} />
			</div>
		</div>
	);
};
